"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadVue = exports.isVue3 = void 0;
const isVue3 = (Vue) => {
    return Vue.version.startsWith('3');
};
exports.isVue3 = isVue3;
const loadVue = () => {
    try {
        const importedModule = require('vue');
        return importedModule.default || importedModule;
    }
    catch (e) {
        throw Error('Vue is not found. Pls install Vue first');
    }
};
exports.loadVue = loadVue;
